(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ads-ingredients-convenience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-ic-section]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach((section) => {
      section.querySelectorAll('[data-ic-add]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.disabled) return;
          const original = button.dataset.label || button.textContent.trim();
          button.disabled = true;
          button.textContent = 'ADDING…';
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({items: [{id: Number(button.dataset.icAdd), quantity: 1}]})
            });
            if (!response.ok) throw new Error('Add to cart failed');
            const added = await response.json();
            button.textContent = 'ADDED!';
            document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: added}}));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.dispatchEvent(new CustomEvent('cart_changed'));
            if (window.Rebuy?.SmartCart?.show) window.Rebuy.SmartCart.show();
            setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
          } catch (error) {
            button.textContent = 'TRY AGAIN';
            setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
          }
        });
      });
      const area = section.querySelector('[data-ic-ingredients]');
      const lens = section.querySelector('[data-ic-lens]');
      if (!area || !lens || reduceMotion) return;
      const stage = lens.closest('.ic-ingredients__stage');
      const sourceImage = stage?.querySelector(':scope > img');
      const lensImage = lens.querySelector('.ic-ingredients__lens-view img');
      if (!stage || !sourceImage || !lensImage) return;
      let ticking = false;
      const update = () => {
        const rect = stage.getBoundingClientRect();
        const stageWidth = stage.clientWidth;
        const stageHeight = stage.clientHeight;
        const lensSize = lens.offsetWidth;
        const stageDocumentTop = rect.top + window.scrollY;
        const isMobile = window.innerWidth < 750;
        const scrollStart = isMobile
          ? Math.max(0, stageDocumentTop - window.innerHeight * 0.62)
          : Math.max(0, stageDocumentTop - Math.min(110, window.innerHeight * 0.12));
        const scrollDistance = isMobile ? Math.min(360, window.innerHeight * 0.45) : 350;
        const progress = Math.max(0, Math.min(1, (window.scrollY - scrollStart) / scrollDistance));
        const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        const startX = lensSize * 0.58;
        const startY = stageHeight * 0.72;
        const targetX = stageWidth * 0.5;
        const targetY = stageHeight * 0.5;
        const lensX = startX + (targetX - startX) * eased;
        const lensY = startY + (targetY - startY) * eased;
        lens.style.setProperty('--ic-lens-x', `${lensX}px`);
        lens.style.setProperty('--ic-lens-y', `${lensY}px`);
        lens.style.setProperty('--ic-lens-scale', `${0.78 + eased * 0.22}`);
        const naturalWidth = sourceImage.naturalWidth || stageWidth;
        const naturalHeight = sourceImage.naturalHeight || stageHeight;
        const coverScale = Math.max(stageWidth / naturalWidth, stageHeight / naturalHeight);
        const renderedWidth = naturalWidth * coverScale;
        const renderedHeight = naturalHeight * coverScale;
        const cropX = (renderedWidth - stageWidth) / 2;
        const cropY = (renderedHeight - stageHeight) / 2;
        const zoom = 1.7;
        lensImage.style.width = `${renderedWidth * zoom}px`;
        lensImage.style.height = `${renderedHeight * zoom}px`;
        lensImage.style.left = `${lensSize / 2 - (lensX + cropX) * zoom}px`;
        lensImage.style.top = `${lensSize / 2 - (lensY + cropY) * zoom}px`;
        ticking = false;
      };
      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      sourceImage.addEventListener('load', requestUpdate, { once: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-code-rename"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESDEVIN' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-nav-hover"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-nav-move"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-b4-nav-space"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-before-benefit-type"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-before-copy-shift"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-before-offer-redesign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-landing-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const triggerParameter = 'free-crepes';
    const triggerValue = '1';
    const freeCrepesVariantId = 46606034599990;

    const initializeFreeCrepesOffer = async () => {
      const currentUrl = new URL(window.location.href);

      if (currentUrl.searchParams.get(triggerParameter) !== triggerValue) return;

      const cleanTriggerFromUrl = () => {
        currentUrl.searchParams.delete(triggerParameter);
        return currentUrl.toString();
      };

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });

        if (!cartResponse.ok) throw new Error('Unable to read the cart.');

        const cart = await cartResponse.json();
        const giftAlreadyInCart = cart.items.some(
          (item) => Number(item.variant_id) === freeCrepesVariantId
        );

        if (giftAlreadyInCart) {
          window.history.replaceState({}, '', cleanTriggerFromUrl());
          return;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: freeCrepesVariantId,
                quantity: 1,
                properties: { _campaign: 'FREECREPESNEWCUSTOMER' },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Unable to add the free crêpes.');

        window.location.replace(cleanTriggerFromUrl());
      } catch (error) {
        console.error('Back-to-School free crêpes offer:', error);
        window.history.replaceState({}, '', cleanTriggerFromUrl());
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFreeCrepesOffer, { once: true });
    } else {
      initializeFreeCrepesOffer();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
